// extracted by mini-css-extract-plugin
export default {"Snackbar":"SnackBar_Snackbar__W7p8V","viewNotification":"SnackBar_viewNotification__brW5h"};